function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveAttendanceShiftApi, detailShiftListApi, putShiftListApi } from '@/api/config';
import { getInervalHour, getInervalTwoHour, getHour } from '@/libs/public';
export default {
  name: 'CrmebOaEntAddShift',
  data: function data() {
    return {
      drawer: false,
      loading: false,
      title: '新增班次',
      options: [{
        value: '0',
        label: '当日'
      }, {
        value: '1',
        label: '次日'
      }],
      goToWork1: [
      // 上班
      {
        premise: '晚到超过',
        suffix: '记为迟到',
        hour: 'lateH',
        minute: 'lateM'
      }, {
        premise: '晚到超过',
        suffix: '记为严重迟到',
        hour: 'extreme_lateH',
        minute: 'extreme_lateM'
      }, {
        premise: '晚到超过',
        suffix: '记为半天缺卡',
        hour: 'late_lack_cardH',
        minute: 'late_lack_cardM'
      }, {
        premise: '最早提前',
        suffix: '进行打卡',
        hour: 'early_cardH',
        minute: 'early_cardM'
      }],
      goToWork2: [
      // 下班
      {
        premise: '提前',
        suffix: '打卡记为早退',
        hour: 'early_leaveH',
        minute: 'early_leaveM'
      }, {
        premise: '提前',
        suffix: '打卡记为半天缺卡',
        hour: 'early_lack_cardH',
        minute: 'early_lack_cardM'
      }, {
        premise: '最晚可延后',
        suffix: '进行打卡',
        hour: 'delay_cardH',
        minute: 'delay_cardM'
      }],
      form1: {
        // 下班form
        lateH: 0,
        // 迟到小时
        lateM: 3,
        // 迟到分钟
        extreme_lateH: 0,
        // 严重迟到小时
        extreme_lateM: 30,
        // 严重迟到分钟
        late_lack_cardH: 2,
        // 缺卡小时
        late_lack_cardM: 30,
        // 缺卡分钟
        early_cardH: 0,
        // 提前打卡小时
        early_cardM: 30,
        // 提前打卡分钟

        early_leaveH: '0',
        // 早退
        early_leaveM: 30,
        // 早退
        early_lack_cardH: '2',
        // 缺卡
        early_lack_cardM: '30',
        // 缺卡
        delay_cardH: '0',
        // 延后打卡
        delay_cardM: '30',
        // 延后打卡
        free_clock: true // 下班免打卡
      },
      form: {
        // 上班form
        lateH: 0,
        // 迟到小时
        lateM: 3,
        // 迟到分钟
        extreme_lateH: 0,
        // 严重迟到小时
        extreme_lateM: 30,
        // 严重迟到分钟
        late_lack_cardH: 2,
        // 缺卡小时
        late_lack_cardM: 30,
        // 缺卡分钟
        early_cardH: 0,
        // 提前打卡小时
        early_cardM: 30,
        // 提前打卡分钟

        early_leaveH: '0',
        // 早退
        early_leaveM: 30,
        // 早退
        early_lack_cardH: '2',
        // 缺卡
        early_lack_cardM: '30',
        // 缺卡
        delay_cardH: '1',
        // 延后打卡
        delay_cardM: '29',
        // 延后打卡
        overtimeH: '0',
        // 加班时长
        overtimeM: '30',
        // 加班时长
        free_clock: true // 下班免打卡
      },
      type: 'add',
      // 判断新增 'add'/编辑 'edit'/查看 'check'
      formData: {
        // 给接口提交的数据
        color: '#1890ff',
        name: '',
        number: '1',
        rest_time: true,
        // 中途休息时间
        rest_start: new Date(0, 0, 0, 12, 0, 0),
        // 休息开始时间
        rest_end: new Date(0, 0, 0, 13, 30, 0),
        //  休息结束时间
        rest_start_after: '0',
        rest_end_after: '0',
        overtime: 1800,
        // 加班起算时间
        work_time: '0',
        number1: {
          first_day_after: '0',
          second_day_after: '0',
          work_hours: new Date(0, 0, 0, 9, 0, 0),
          // work_hours
          late: 600,
          // 迟到
          extreme_late: 1800,
          // 严重迟到
          late_lack_card: 3600,
          // 半天缺卡
          early_card: 1800,
          // 提前打卡

          off_hours: new Date(0, 0, 0, 18, 0, 0),
          // 下班时间
          early_leave: 600,
          // 早退
          early_lack_card: 1800,
          // 半天缺卡
          delay_card: 1800,
          // 延后打卡
          free_clock: true // 下班可免打卡
        },
        number2: {
          first_day_after: '0',
          work_hours: new Date(0, 0, 0, 14, 0, 0),
          // work_hours
          late: 600,
          // 迟到
          extreme_late: 1800,
          // 严重迟到
          late_lack_card: 3600,
          // 半天缺卡
          early_card: 1800,
          // 提前打卡
          second_day_after: '0',
          off_hours: new Date(0, 0, 0, 18, 0, 0),
          // 下班时间
          early_leave: 600,
          // 早退
          early_lack_card: 1800,
          // 半天缺卡
          delay_card: 1800,
          // 延后打卡
          free_clock: true // 下班可免打卡
        }
      },
      rules: {
        name: [{
          required: true,
          message: '请输入班次名称',
          trigger: 'blur'
        }],
        number: [{
          required: true,
          message: '请选择班次',
          trigger: 'change'
        }]
      },
      tableData: [{
        name: '上班1',
        rule: 1
      }, {
        name: '下班1',
        rule: 2
      }],
      id: null
    };
  },
  methods: {
    // 计算工作时长
    changeTime: function changeTime() {
      var duration1 = null;
      if (this.formData.number == 1 && this.formData.rest_time == 1) {
        if (this.formData.number1.second_day_after == 0) {
          if (this.formData.number1.work_hours > this.formData.rest_start) {
            return this.$message.error('中途休息开始时间要大于上班时间');
          }
          if (this.formData.number1.off_hours < this.formData.rest_end) {
            return this.$message.error('中途休息结束时间要小于下班时间');
          }
        } else {
          if (this.formData.rest_start_after == 0) {
            if (this.formData.number1.work_hours > this.formData.rest_start) {
              return this.$message.error('中途休息开始时间要大于上班时间');
            }
          }
          if (this.formData.rest_end_after == 1) {
            if (this.formData.number1.off_hours < this.formData.rest_end) {
              return this.$message.error('中途休息结束时间要小于下班时间');
            }
          }
        }
        if (!this.formData.rest_time) {
          if (this.formData.number1.work_hours && this.formData.number1.off_hours) {
            if (this.formData.number1.second_day_after == 0) {
              duration1 = getInervalHour(this.formData.number1.work_hours, this.formData.number1.off_hours);
            } else {
              duration1 = getInervalHour(this.formData.number1.work_hours, this.formData.number1.off_hours);
              duration1[0] = parseInt(duration1[0] + 24);
            }
          }
        } else {
          if (this.formData.rest_start && this.formData.rest_end) {
            if (this.formData.number1.second_day_after == 0) {
              this.formData.rest_start_after = '0';
              this.formData.rest_end_after = '0';
              duration1 = getInervalTwoHour(this.formData.number1.work_hours, this.formData.number1.off_hours, this.formData.rest_start, this.formData.rest_end);
            } else {
              if (this.formData.rest_start_after == 1) {
                this.formData.rest_end_after = '1';
              }
              duration1 = getInervalTwoHour(this.formData.number1.work_hours, this.formData.number1.off_hours, this.formData.rest_start, this.formData.rest_end);
              if (this.formData.rest_start_after == 0 && this.formData.rest_end_after == 1) {
                duration1[0] = parseInt(duration1[0] + 24 - 24);
              } else {
                duration1[0] = parseInt(duration1[0] + 24);
              }
            }
          }
        }
      } else {
        if (this.formData.number1.second_day_after == 1) {
          this.formData.number2.first_day_after = '1';
        }
        if (this.formData.number2.first_day_after == 1) {
          this.formData.number2.second_day_after = '1';
        }
        if (this.formData.number1.second_day_after == 0 && Date.parse(new Date(this.formData.number1.off_hours)) < Date.parse(new Date(this.formData.number1.work_hours))) {
          return this.$message.error('下班时间要大于上班时间');
        }
        duration1 = getHour(this.formData.number1.work_hours, this.formData.number1.off_hours, this.formData.number2.work_hours, this.formData.number2.off_hours);
        if (this.formData.number1.second_day_after == 1) {
          duration1[0] = parseInt(duration1[0] + 24);
        }
        if (this.formData.number2.first_day_after == 0 && this.formData.number2.second_day_after == 1) {
          duration1[0] = parseInt(duration1[0] + 24);
        }
      }
      this.formData.work_time = duration1[0] + '小时' + duration1[1] + '分钟';
    },
    // 切换单选
    radioFn: function radioFn() {
      var _this = this;
      var obj = [{
        name: '上班2',
        rule: 3
      }, {
        name: '下班2',
        rule: 4
      }];
      if (this.formData.number == 2) {
        obj.map(function (item) {
          _this.tableData.push(item);
        });
        this.formData.number1.off_hours = new Date(0, 0, 0, 12, 0, 0);
      }
      if (this.formData.number == 1) {
        this.formData.number1.off_hours = new Date(0, 0, 0, 18, 0, 0);
        this.tableData = [{
          name: '上班1',
          rule: 1
        }, {
          name: '下班1',
          rule: 2
        }];
      }
      this.changeTime();
    },
    getTimestampData: function getTimestampData(timeString) {
      var _timeString$split = timeString.split(':'),
        _timeString$split2 = _slicedToArray(_timeString$split, 2),
        hours = _timeString$split2[0],
        minutes = _timeString$split2[1];
      var timestamp = new Date(0, 0, 0, hours, minutes, 0);
      return timestamp;
    },
    // 秒转化为小时和分钟
    format: function format(num) {
      return [''.repeat(2 - String(Math.floor(num / 3600)).length) + Math.floor(num / 3600), ''.repeat(2 - String(Math.floor(num % 3600 / 60)).length) + Math.floor(num % 3600 / 60)];
    },
    // 编辑-查看回显数据
    openBox: function openBox(id, type) {
      var _this2 = this;
      this.type = type;
      if (type == 'edit') {
        this.title = '编辑班次';
      } else if (type == 'check') {
        this.title = '查看班次';
      } else {
        this.type = 'add';
        this.title = '新建班次';
        this.changeTime();
      }
      if (id) {
        this.id = id;
        detailShiftListApi(id).then(function (res) {
          _this2.formData.number = res.data.number + '';
          _this2.radioFn();
          _this2.formData.name = res.data.name;
          _this2.formData.number1.first_day_after = res.data.number1.first_day_after + '';
          _this2.formData.number1.second_day_after = res.data.number1.second_day_after + '';
          _this2.form.free_clock = res.data.number1.free_clock == 0 ? false : true;
          _this2.form1.free_clock = res.data.number2.free_clock == 0 ? false : true;
          _this2.formData.number1.free_clock = _this2.form.free_clock;
          _this2.formData.number2.free_clock = _this2.form1.free_clock;
          _this2.formData.rest_time = res.data.rest_time == 1 ? true : false;
          _this2.form.overtimeH = _this2.format(res.data.overtime)[0];
          _this2.form.overtimeM = _this2.format(res.data.overtime)[1];
          _this2.formData.work_time = res.data.work_time;
          var _res$data = res.data,
            number1 = _res$data.number1,
            number2 = _res$data.number2;
          _this2.formData.rest_end = _this2.getTimestampData(res.data.rest_end);
          _this2.formData.rest_start = _this2.getTimestampData(res.data.rest_start);
          _this2.formData.color = res.data.color;

          // 秒转化为时分赋值
          if (number1) {
            _this2.formData.number1.work_hours = _this2.getTimestampData(number1.work_hours);
            _this2.formData.number1.off_hours = _this2.getTimestampData(number1.off_hours);
            _this2.form.lateH = _this2.format(number1.late)[0];
            _this2.form.lateM = _this2.format(number1.late)[1];
            _this2.form.extreme_lateH = _this2.format(number1.extreme_late)[0];
            _this2.form.extreme_lateM = _this2.format(number1.extreme_late)[1];
            _this2.form.late_lack_cardH = _this2.format(number1.late_lack_card)[0];
            _this2.form.late_lack_cardM = _this2.format(number1.late_lack_card)[1];
            _this2.form.early_cardH = _this2.format(number1.early_card)[0];
            _this2.form.early_cardM = _this2.format(number1.early_card)[1];
            _this2.form.early_leaveH = _this2.format(number1.early_leave)[0];
            _this2.form.early_leaveM = _this2.format(number1.early_leave)[1];
            _this2.form.early_lack_cardH = _this2.format(number1.early_lack_card)[0];
            _this2.form.early_lack_cardM = _this2.format(number1.early_lack_card)[1];
            _this2.form.delay_cardH = _this2.format(number1.delay_card)[0];
            _this2.form.delay_cardM = _this2.format(number1.delay_card)[1];
            _this2.form.free_clock = number1.free_clock == 0 ? false : true;
          }
          if (number2.length !== 0) {
            _this2.formData.number2.work_hours = _this2.getTimestampData(number2.work_hours);
            _this2.formData.number2.off_hours = _this2.getTimestampData(number2.off_hours);
            _this2.form1.lateH = _this2.format(number2.late)[0];
            _this2.form1.lateM = _this2.format(number2.late)[1];
            _this2.form1.extreme_lateH = _this2.format(number2.extreme_late)[0];
            _this2.form1.extreme_lateM = _this2.format(number2.extreme_late)[1];
            _this2.form1.late_lack_cardH = _this2.format(number2.late_lack_card)[0];
            _this2.form1.late_lack_cardM = _this2.format(number2.late_lack_card)[1];
            _this2.form1.early_cardH = _this2.format(number2.early_card)[0];
            _this2.form1.early_cardM = _this2.format(number2.early_card)[1];
            _this2.form1.early_leaveH = _this2.format(number2.early_leave)[0];
            _this2.form1.early_leaveM = _this2.format(number2.early_leave)[1];
            _this2.form1.early_lack_cardH = _this2.format(number2.early_lack_card)[0];
            _this2.form1.early_lack_cardM = _this2.format(number2.early_lack_card)[1];
            _this2.form1.delay_cardH = _this2.format(number2.delay_card)[0];
            _this2.form1.delay_cardM = _this2.format(number2.delay_card)[1];
            _this2.form1.free_clock = number2.free_clock == 0 ? false : true;
            _this2.formData.number2.first_day_after = res.data.number2.first_day_after + '';
            _this2.formData.number2.second_day_after = res.data.number2.second_day_after + '';
          }
        });
      }
      this.drawer = true;
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this3 = this;
      if (!this.formData.name) {
        return this.$message.error('班次名称不能为空');
      }
      // 计算工作时长函数
      this.changeTime();
      // 数据转化秒函数
      this.conversion();
      if (this.formData.number1.late > this.formData.number1.extreme_late) {
        return this.$message.error('严重迟到值要大于迟到');
      }
      if (this.formData.number1.extreme_late > this.formData.number1.late_lack_card) {
        return this.$message.error('半天缺卡值要大于严重迟到');
      }
      if (this.formData.number1.early_leave > this.formData.number1.early_lack_card) {
        return this.$message.error('半天缺卡要大于早退值要大于严重迟到');
      }
      if (this.formData.number == 2) {
        if (this.formData.number2.late > this.formData.number2.extreme_late) {
          return this.$message.error('严重迟到值要大于迟到');
        }
        if (this.formData.number2.extreme_late > this.formData.number2.late_lack_card) {
          return this.$message.error('半天缺卡值要大于严重迟到');
        }
        if (this.formData.number2.early_leave > this.formData.number2.early_lack_card) {
          return this.$message.error('半天缺卡要大于早退值要大于严重迟到');
        }
        this.formData.number2.work_hours = this.$moment(this.formData.number2.work_hours).format('H:mm');
        this.formData.number2.off_hours = this.$moment(this.formData.number2.off_hours).format('H:mm');
      }
      this.formData.number1.work_hours = this.$moment(this.formData.number1.work_hours).format('H:mm');
      this.formData.number1.off_hours = this.$moment(this.formData.number1.off_hours).format('H:mm');
      this.formData.rest_start = this.$moment(this.formData.rest_start).format('H:mm');
      this.formData.rest_end = this.$moment(this.formData.rest_end).format('H:mm');
      this.formData.rest_time = this.formData.rest_time ? 1 : 0;
      this.formData.number1.free_clock = this.form.free_clock ? 1 : 0;
      this.formData.number2.free_clock = this.form1.free_clock ? 1 : 0;
      if (this.type == 'add') {
        this.loading = true;
        saveAttendanceShiftApi(this.formData).then(function (res) {
          if (res.status == 200) {
            _this3.handleClose();
            _this3.drawer = false;
            _this3.loading = false;
            _this3.$emit('getList');
          } else {
            _this3.loading = false;
            _this3.abbreviatedData();
          }
        }).catch(function (err) {
          _this3.loading = false;
          _this3.abbreviatedData();
        });
      } else {
        this.loading = true;
        putShiftListApi(this.id, this.formData).then(function (res) {
          if (res.status == 200) {
            _this3.handleClose();
            _this3.drawer = false;
            _this3.loading = false;
            _this3.$emit('getList');
          } else {
            _this3.loading = false;
            _this3.abbreviatedData();
          }
        }).catch(function (err) {
          _this3.loading = false;
          _this3.abbreviatedData();
        });
      }
    },
    // 格式化日期
    abbreviatedData: function abbreviatedData() {
      this.formData.rest_end = this.getTimestampData(this.formData.rest_end);
      this.formData.rest_start = this.getTimestampData(this.formData.rest_start);
      this.formData.number1.work_hours = this.getTimestampData(this.formData.number1.work_hours);
      this.formData.number1.off_hours = this.getTimestampData(this.formData.number1.off_hours);
      if (this.formData.number == 2) {
        this.formData.number2.work_hours = this.getTimestampData(this.formData.number2.work_hours);
        this.formData.number2.off_hours = this.getTimestampData(this.formData.number2.off_hours);
      }
    },
    // 提交时分转化为秒拼接字段传给后端
    conversion: function conversion() {
      this.formData.number1.late = parseInt(this.form.lateH * 3600) + parseInt(this.form.lateM * 60);
      this.formData.number1.extreme_late = parseInt(this.form.extreme_lateH * 3600) + parseInt(this.form.extreme_lateM * 60);
      this.formData.number1.late_lack_card = parseInt(this.form.late_lack_cardH * 3600) + parseInt(this.form.late_lack_cardM * 60);
      this.formData.number1.early_card = parseInt(this.form.early_cardH * 3600) + parseInt(this.form.early_cardM * 60);
      this.formData.overtime = parseInt(this.form.overtimeH * 3600) + parseInt(this.form.overtimeM * 60);
      this.formData.number1.early_leave = parseInt(this.form.early_leaveH * 3600) + parseInt(this.form.early_leaveM * 60);
      this.formData.number1.early_lack_card = parseInt(this.form.early_lack_cardH * 3600) + parseInt(this.form.early_lack_cardM * 60);
      this.formData.number1.delay_card = parseInt(this.form.delay_cardH * 3600) + parseInt(this.form.delay_cardM * 60);
      this.formData.number1.rest_time = this.formData.number1.rest_time ? '1' : '0';
      if (this.formData.number == 2) {
        this.formData.number2.late = parseInt(this.form1.lateH * 3600) + parseInt(this.form1.lateM * 60);
        this.formData.number2.extreme_late = parseInt(this.form1.extreme_lateH * 3600) + parseInt(this.form1.extreme_lateM * 60);
        this.formData.number2.late_lack_card = parseInt(this.form1.late_lack_cardH * 3600) + parseInt(this.form1.late_lack_cardM * 60);
        this.formData.number2.early_card = parseInt(this.form1.early_cardH * 3600) + parseInt(this.form1.early_cardM * 60);
        this.formData.number2.early_leave = parseInt(this.form1.early_leaveH * 3600) + parseInt(this.form1.early_leaveM * 60);
        this.formData.number2.early_lack_card = parseInt(this.form1.early_lack_cardH * 3600) + parseInt(this.form1.early_lack_cardM * 60);
        this.formData.number2.delay_card = parseInt(this.form1.delay_cardH * 3600) + parseInt(this.form1.delay_cardM * 60);
      }
    },
    handleCloseFn: function handleCloseFn() {
      this.handleClose(1);
    },
    handleClose: function handleClose(val) {
      this.tableData = [{
        name: '上班1',
        rule: 1
      }, {
        name: '下班1',
        rule: 2
      }];
      this.formData.color = '#1890ff';
      this.formData.name = '';
      this.formData.number = '1';
      this.formData.rest_start = new Date(0, 0, 0, 12, 0, 0);
      this.formData.rest_end = new Date(0, 0, 0, 13, 30, 0);
      this.formData.number1.work_hours = new Date(0, 0, 0, 9, 0, 0);
      this.formData.number1.off_hours = new Date(0, 0, 0, 18, 0, 0);
      this.formData.number2.work_hours = new Date(0, 0, 0, 14, 0, 0);
      this.formData.number2.off_hours = new Date(0, 0, 0, 18, 0, 0);
      this.form1 = {
        lateH: 0,
        lateM: 3,
        extreme_lateH: 0,
        extreme_lateM: 30,
        late_lack_cardH: 2,
        late_lack_cardM: 30,
        early_cardH: 1,
        early_cardM: 0,
        early_leaveH: '0',
        early_leaveM: 30,
        early_lack_cardH: '2',
        early_lack_cardM: '30',
        delay_cardH: '0',
        delay_cardM: '30',
        free_clock: true
      };
      this.form = {
        lateH: 0,
        lateM: 3,
        extreme_lateH: 0,
        extreme_lateM: 30,
        late_lack_cardH: 2,
        late_lack_cardM: 30,
        early_cardH: 2,
        early_cardM: 0,
        early_leaveH: '0',
        early_leaveM: 30,
        early_lack_cardH: '2',
        early_lack_cardM: '30',
        delay_cardH: '0',
        delay_cardM: '30',
        overtimeH: '0',
        overtimeM: '30',
        free_clock: true
      };
      if (val == 1) {
        this.drawer = false;
      }
      this.$refs.ruleForm.resetFields();
    }
  }
};